import repository from "../Repository";

export default {
  async list(screenId) {
    return await repository.post("car/car-list", {
      headers: {
        s: screenId
      }
    });
  },
  async detail(screenId, payload) {
    return await repository.post("car/car-detail", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async entry(screenId, payload) {
    return await repository.post("car/car-entry", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.post("car/car-update", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.post("car/car-delete", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
